<script lang="ts">
  import NoMatchIcon from '$shared/images/no-match.svg';

  interface Props {
    label?: string;
  }

  let { label = '' }: Props = $props();
</script>

<div data-cy="not-found-view" class="no-match-view">
  <div class="container">
    <div class="icon"><img src={NoMatchIcon} alt="No match icon" /></div>
    {#if label}
      <div data-cy="not-found-label" class="label">{label}</div>
    {/if}
  </div>
</div>

<style>
  .no-match-view {
    background-color: var(--grey-bg);
    width: 100%;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .label {
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    margin-top: 12px;
  }
</style>
